export class Warnings {
  proceedToNextStep: boolean = true;
  isOnSaleQtyMoreOnHand: boolean = false;
  showAlternateOptionsForBackOrder: boolean = false;
  warnings: string[];
}
